import { createBrowserHistory } from 'history'

import { setupStore } from './store'

export default setupStore(createBrowserHistory())



// WEBPACK FOOTER //
// ./src/downSetup.js